import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import App from './App'
import { CACHE_KEY } from './lib/cache'
import './index.css'

// Offline: cache localStorage'a yazılır, ağ yokken uygulama son bilinen veriyle açılır.
// localStorage artık KAYNAK değil, sadece önbellek — kaynak sunucudaki SQLite.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24 * 14,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      // Ağ döndüğünde kuyruktaki mutasyonlar tekrar denenir.
      // PUT'lar idempotent olduğu için bu güvenli.
      retry: 3,
      retryDelay: (n) => Math.min(1000 * 2 ** n, 30_000),
    },
  },
})

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: CACHE_KEY,
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      <App />
    </PersistQueryClientProvider>
  </StrictMode>,
)
